import { makeEnvironmentAwareSearchParamsParser } from '@gonfalon/app-context/makeEnvironmentAwareSearchParamsParser';

import { parseUIFlagListViewFromBrowser } from './parseUIFlagListViewFromBrowser';

export const parseEnvironmentAwareUIFlagListViewFromBrowser =
  makeEnvironmentAwareSearchParamsParser(parseUIFlagListViewFromBrowser);
